export const LocalStorageItems = {
  GatsbyToken: `gatsby:token`,
  GatsbyUserId: `gatsby:userid`,
  GatsbyTokenExpiration: `gatsby:token-expiration`,
  GatsbySessionId: `gatsby:sessionId`,
  GatsbyOrganizationId: `gatsby:orgId`,
  GatsbyCloudStatusPage: `gatsby:statusPage`,
  GatsbySsoToken: `gatsby:ssotoken`,
  GatsbySsoTokenExpiration: `gatsby:ssotoken-expiration`,
  GatsbySelectedProvider: `gatsby:selected-provider`,
  GatsbyTrialPromptInteraction: `gatsby:trial-prompt`,
  GatsbyProviderConfigId: `gatsby:providerConfigId`,
}

export const SessionStorageItems = {
  NewSpaceForm: `newSpaceForm`,
}
